import { Injectable } from '@angular/core';

// import * as CryptoJS from 'crypto-js';
import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';

@Injectable()
export class EncryptService {
  constructor(private env: MessagingEnvironmentService) {}

  // decrypt(message: string): string {
  //   const encryptedBase64Key = this.env.env.cryptoPswd;
  //   const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
  //   return CryptoJS.AES.decrypt(message.trim(), parsedBase64Key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   }).toString(CryptoJS.enc.Utf8);
  // }
}
